<template>
  <VueTelInput
    v-model="modelValue"
    default-country="kz"
    :preferred-countries="['kz', 'ru', 'kg', 'cn']"
    mode="international"
    :valid-characters-only="true"
    :input-options="{
      type: 'tel',
      showDialCode: showDialCode,
      maxlength: 25,

    }"
    :dropdown-options="{
      showFlags: true,
      showDialCodeInList: true,
    }"
    v-bind="$attrs"
  />
</template>

<script setup>
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';

const modelValue = defineModel({ type: [String, null] });

defineProps({
  showDialCode: {
    type: Boolean,
    default: true,
  },
});
</script>

<style lang="scss" scoped>
.vue-tel-input {
  @apply border-0 bg-neutral-50 rounded-lg relative;
}

.vti__dropdown-item.highlighted {
  @apply bg-white #{!important};
}

.vti__dropdown-list.below {
  @apply top-12;
}

.vti__dropdown-list {
  @apply shadow-xl border-0 rounded-lg min-w-fit w-full;

  li {
    @apply p-1 font-normal hover:text-secondary-500 whitespace-nowrap hover:bg-none;


    strong {
      @apply font-normal;
    }
  }
}

.vti__dropdown:hover {
  @apply rounded-lg;
}
</style>
